import { Backdrop } from "@mui/material";
import { rem } from "assets/js/common";
import React, { useContext, useEffect, useState } from "react";

export default function Loading(props) {
  //   const [open, setOpen] = useState(true);

  //   const handleClose = () => {
  //     setOpen(false);
  //   };

  let open = props.open;

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
        // onClick={handleClose}
      >
        <img
          src={`${process.env.PUBLIC_URL}/images/gif/loading.gif`}
          style={{ width: rem(66), height: rem(66) }}
        />
      </Backdrop>
    </>
  );
}
